import { eTipoPermissao } from '@/enums/ePermissoes';

/**
 * Histórico Escolar do estudante — migração de `CadastrarHistoricoAluno.aspx`.
 *
 * As subtelas do legado (`EditarHistorico`, `CargaHorariaHistorico2`,
 * `TrocaSerieDoHistorico`) NÃO ganharam rota: elas eram janelas MDI empilhadas sobre a mesma
 * informação, e viraram seções da rota `historico_escolar_estudante`.
 *
 * Permissão: `HISTORICONOVO_MENU_300700199`, criada para estas telas. A tela nova NÃO reusa a
 * `HISTORICO_MENU_300700100` do legado — quem libera a tela antiga não libera a nova por
 * tabela, e vice-versa. Ver `consultebase/scripts/2026-08-28-Permissoes-TelasNovas.sql`.
 */
export default [
  {
    description: 'Leis / Observações do Histórico',
    path: '/academico/historicoescolar/leis',
    name: 'historico_escolar_leis',
    component: () => import('@/views/academico/historicoescolar/Leis.vue'),
    meta: {
      permissions: [eTipoPermissao.LEISNOVO_MENU_300700197],
    },
    goesToMenu: true,
  },
  {
    description: 'Histórico Escolar',
    path: '/academico/historicoescolar',
    name: 'historico_escolar',
    component: () => import('@/views/academico/historicoescolar/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.HISTORICONOVO_MENU_300700199],
    },
    goesToMenu: true,
  },
  {
    description: 'Histórico Escolar do Estudante',
    path: '/academico/historicoescolar/:id',
    parent: 'historico_escolar',
    name: 'historico_escolar_estudante',
    component: () => import('@/views/academico/historicoescolar/Historico.vue'),
    meta: {
      permissions: [eTipoPermissao.HISTORICONOVO_MENU_300700199],
    },
    goesToMenu: false,
  },
];
